import * as React from 'react';

import user from 'js/lib/user';

import CatalogSection from 'bundles/enterprise-legacy-learner-home/components/single-program/CatalogSection';
import MyRecentActivity from 'bundles/enterprise-legacy-learner-home/components/single-program/MyRecentActivity';
import { toProgramHomeTab } from 'bundles/enterprise-legacy-learner-home/links';
import { TabName } from 'bundles/unified-common/constants/enterprise';
import { useProgram, useProgramMembership } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

export const EnterpriseMyRecentActivityNotConfigurableModule = () => {
  const program = useProgram();
  const programMembership = useProgramMembership();
  const isProgramMember = programMembership?.isProgramMember;
  const isAuthenticatedUser = user.isAuthenticatedUser();

  if (isAuthenticatedUser && isProgramMember && program) {
    <CatalogSection data-test="my-recent-activity-section">
      <MyRecentActivity
        programId={program?.id}
        viewMyCoursesUrl={toProgramHomeTab(program?.metadata.slug, TabName.MyCourses)}
        userId={user.get().id}
        thirdPartyOrganizationId={program?.thirdPartyOrganizationId}
      />
    </CatalogSection>;
  }

  return null;
};
